var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYamluploader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 103,
    viewBox: "0 0 117 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: 11.0424,
    y: 10.0993,
    width: 81.9982,
    height: 68.332
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(4.56px)",
      clipPath: "url(#bgblur_0_10699_4492_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-figma-bg-blur-radius": 9.11093,
    x: 20.1533,
    y: 19.2102,
    width: 63.7765,
    height: 50.1101,
    rx: 13.6664,
    fill: "url(#paint0_linear_10699_4492)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28.3516,
    y: 32.7599,
    width: 64.5,
    height: 50.5,
    rx: 13,
    fill: "url(#paint1_linear_10699_4492)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.128 43.5221H48.5568V53.1305H72.128V43.5221Z",
    fill: "url(#paint2_linear_10699_4492)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.128 65.6918H48.5568V75.3002H72.128V65.6918Z",
    fill: "url(#paint3_linear_10699_4492)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1982 54.0772H46.1982V64.6617H74.1982V54.0772Z",
    fill: "url(#paint4_linear_10699_4492)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5701 60.816C51.5701 60.6631 51.6083 60.5553 51.6858 60.4916C51.7632 60.4279 51.8573 60.3965 51.968 60.3965C52.0807 60.3965 52.1758 60.4279 52.2542 60.4916C52.3326 60.5553 52.3718 60.6631 52.3718 60.816C52.3718 60.9649 52.3326 61.0737 52.2542 61.1413C52.1758 61.209 52.0807 61.2443 51.968 61.2443C51.8573 61.2443 51.7632 61.2099 51.6858 61.1413C51.6093 61.0727 51.5701 60.964 51.5701 60.816Z",
    fill: "#49454F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5786 58.8618L55.688 56.7518H56.3515L54.8863 59.4469V61.1591H54.2679V59.4734L52.7998 56.7508H53.4751L54.5786 58.8618Z",
    fill: "#49454F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6922 61.159L59.2041 59.8477H57.4763L56.9941 61.159H56.3521L58.0349 56.7331H58.668L60.3409 61.159H59.6922ZM59.0326 59.3116L58.568 58.0121C58.5543 57.968 58.5328 57.9013 58.5034 57.8131C58.474 57.7249 58.4455 57.6338 58.4161 57.5387C58.3867 57.4446 58.3632 57.3662 58.3456 57.3035C58.325 57.3858 58.3024 57.4731 58.276 57.5642C58.2495 57.6554 58.224 57.7416 58.1995 57.821C58.1741 57.9004 58.1535 57.9641 58.1378 58.0121L57.6674 59.3116H59.0326Z",
    fill: "#49454F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8574 61.1591L61.4824 57.3692H61.4579C61.4638 57.4515 61.4706 57.5574 61.4775 57.6877C61.4844 57.8171 61.4903 57.9582 61.4952 58.1101C61.5001 58.262 61.503 58.411 61.503 58.558V61.16H60.9365V56.7528H61.8254L63.1309 60.3437H63.1534L64.4921 56.7528H65.3752V61.16H64.7783V58.5217C64.7783 58.3894 64.7803 58.2513 64.7842 58.1072C64.7881 57.9631 64.794 57.8269 64.8009 57.6975C64.8077 57.5682 64.8146 57.4613 64.8205 57.3761H64.793L63.3847 61.16L62.8574 61.1591Z",
    fill: "#49454F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5568 61.1591V56.7518H67.1752V60.623H69.0893V61.16L66.5568 61.1591Z",
    fill: "#49454F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_10699_4492_clip_path",
    transform: "translate(-11.0424 -10.0993)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.1533,
    y: 19.2102,
    width: 63.7765,
    height: 50.1101,
    rx: 13.6664
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10699_4492",
    x1: 38.5504,
    y1: 30.1718,
    x2: 89.0739,
    y2: 52.6408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F4690"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10699_4492",
    x1: 60.6016,
    y1: 32.7599,
    x2: 60.6016,
    y2: 83.2599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#547ED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E9F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10699_4492",
    x1: 60.1982,
    y1: 43.5221,
    x2: 60.1982,
    y2: 75.3002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10699_4492",
    x1: 60.1982,
    y1: 43.5221,
    x2: 60.1982,
    y2: 75.3002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10699_4492",
    x1: 60.1982,
    y1: 43.5221,
    x2: 60.1982,
    y2: 75.3002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF3FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYamluploader);
export default __webpack_public_path__ + "static/media/yamluploader.6f4f6cd1768683515c216c90ee7e5030.svg";
export { ForwardRef as ReactComponent };